const RouterPaths = {
  COMMERCIAL: '/',
  HOUSEHOLD: '/household',
  ABOUT: '/about',
  CONTACT: '/contact',
  PRIVACY: '/privacy',
};

export default RouterPaths;
